import {LanguageCode, LanguageName} from "../constants/Enums";

export default (id) => {
    return {
        id,
        name: LanguageCode[id],
        fullName: LanguageName[id]
    }
}
